import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAppSettings } from "@/hooks/useAppSettings";
import { useIsAdmin } from "@/hooks/useIsAdmin";
import { PageLoader } from "@/components/PageLoader";

interface Props {
  flag: "academy" | "shop";
  children: ReactNode;
  fallback?: string;
}

/**
 * Bloquea rutas según flags de visibilidad. Si el flag está OFF y el usuario
 * no es admin, redirige a /dashboard. Admins siempre pasan.
 */
export function FeatureGate({ flag, children, fallback = "/dashboard" }: Props) {
  const { settings, isLoading } = useAppSettings();
  const { isAdmin, loading: adminLoading } = useIsAdmin();

  if (isLoading || adminLoading) return <PageLoader />;

  const enabled = flag === "academy" ? settings.academyEnabled : settings.shopEnabled;
  if (!enabled && !isAdmin) return <Navigate to={fallback} replace />;

  return <>{children}</>;
}
